import { useAxiosClient } from "../../hooks/providers/ApiProvider";
import { useMutation } from "@tanstack/react-query";
import {
  LoginDtoApiResponse,
  LoginResponseDtoApiResponse,
  RefreshCommand,
} from "../generated";
import { AuthModule } from "../../hooks/providers/AuthProvider";

// Login request
export const useLoginRequest = () => {
  const client = useAxiosClient();
  const result = useMutation<
    LoginResponseDtoApiResponse,
    Error,
    AuthModule.UserRequest
  >({
    mutationKey: ["login.user"],
    mutationFn: (variables) =>
      client.auth.postApiAuthLogin({
        email: variables.email.trim(),
        password: variables.password.trim(),
      }),
  });

  const data = result.data?.data;
  return { ...result, data: data };
};

// Logout request
export const useLogoutRequest = () => {
  const client = useAxiosClient();
  const result = useMutation({
    mutationKey: ["logout.user"],
    mutationFn: () => {
      return client.auth.postApiAuthLogout();
    },
  });

  const data = result.data?.data;
  return { ...result, data: data };
};

// Refresh access token request
export const useRefreshTokenRequest = () => {
  const client = useAxiosClient();
  const result = useMutation<LoginDtoApiResponse, Error, RefreshCommand>({
    mutationKey: ["refresh.user.access.token"],
    mutationFn: (variables) => client.auth.postApiAuthRefreshToken(variables),
  });

  const data = result.data?.data;
  return { ...result, data: data };
};
